<app-banner [heading]="'ADMISSIONS FORM'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
	<!-- ======= About Section ======= -->
    <section id="about" class="about">

      <div class="container">
        <div class="row">

          <div class="col-lg-12 col-md-6">
			<p class="heading2">ADMISSION FORM FOR THE NEW SESSION 2021-22</p>
					<!-- ======= Table Section ======= -->
					<table class="table table-hover">
						  <thead>
							<tr>
							  <th width="5%">S.NO.</th>
							  <th width="70%">DOCUMENTS/INFORMATION</th>
							  <th width="25%">DOWNLOAD</th>
							</tr>
						  </thead>
						  <tbody>
							<tr>
							  <th scope="row">1</th>
							  <td>ADMISSION FORM  </td>
							  <td class=""><a href="https://drive.google.com/file/d/1Z8XSqLTyRxNu-ulg8ylhG6IyGkhluf-E/view?usp=sharing" target="_blank">VIEW &amp; DOWNLOAD</a></td>
							  
							</tr>
							</tbody>
     				</table>
            
          </div>

          
		</div>
      </div>
	</section><!-- End About Section -->
	

	
	
    
    
  </main>